import { Box, Grid, IconButton, TableCell, Tooltip, tooltipClasses, TooltipProps, Typography } from '@mui/material'
import { styled as MUIStyled } from '@mui/material/styles';
import { INFO_ICON } from '../../../../constants/icons/InfoIcon'
import { useRef } from 'react'
import styled from '@emotion/styled'
import { TABLE_CONSTANTS } from '../../constants'
import { COLOR_MAP } from '../../../../constants/ColorNames'
import { BarChart } from '../../../../common/components/BarChart'
import { GreenPassiveBox } from './TableContent'

type DataPillProps = {
  label: string,
  count: string,
  percentage: string
}

type CampaignStageDetailsPropsType = {
  campaignStageData: any,
  isSelectedCampaign?: boolean
  isWhatsAppCampaign: boolean
}
const DataPillWrapper = styled.div`
 display: flex;
 align-items: center;
 gap: 4px;
`

const Bullet = styled.div`
  width: 12px;
  height: 8px;
  border-radius: 2px;
  background-color: ${COLOR_MAP.GREY_1};
`
const DataPercentage = styled.span`
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  color: ${COLOR_MAP.GREY_2};
`
const DataInfo = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.04rem;
  color: ${COLOR_MAP.GREY_2};
`

const ToolTipTitleContainer = styled.div`
display:flex;
flex-direction:column;
gap:4px;
`
const DataPillContainer = styled.div`
font-size:10px;
font-weight:400;
line-height:14px;
`
const InfoText = styled.span`
color:#777584;
`

const InfoTextBold = styled.span`
color:#17142A;
font-weight:600;
`


const DataPill = (props: DataPillProps) => {
  const { label, count, percentage } = props;

  return (
    <DataPillWrapper>
      <Bullet></Bullet>
      <DataInfo>{label} - {count}(<DataPercentage>{percentage}%</DataPercentage>)</DataInfo>
    </DataPillWrapper>
  )
}


const getPillData = (data: any, isWhatsAppCampaign:boolean) => {

  if(isWhatsAppCampaign){
    return (
      [
        {
          label: 'Skipped',
          count: data?.skippedCount || 0,
          percentage: data?.skippedCount ? Math.floor((data?.skippedCount * 100) / data?.assigned) : data?.skippedCount || 0
        },
        {
          label: 'Unsubscribed',
          count: data?.unsubscribed || 0,
          percentage: data?.unsubscribed ? Math.floor((data?.unsubscribed * 100) / data?.assigned) : data?.unsubscribed || 0
        },
        {
          label: 'Undelivered',
          count: data?.nonContactable || 0,
          percentage: data?.nonContactable ? Math.floor((data?.nonContactable * 100) / data?.assigned) : data?.nonContactable||0
        }
      ]
    )
  }

  const nonContactableCount = (data?.nonContactable || 0) + (data?.skippedCount || 0)

  return (
    [
      {
        label: 'Non-contactable',
        count: nonContactableCount,
        percentage: nonContactableCount ? Math.floor((nonContactableCount * 100) / data?.assigned) : nonContactableCount
      },
      // {
      //   label: 'Skipped',
      //   count: data?.skippedCount || 0,
      //   percentage: data?.skippedCount ? Math.floor((data?.skippedCount * 100) / data?.assigned) : data?.skippedCount || 0
      // },
      {
        label: 'Bounced',
        count: data?.bounced,
        percentage: data?.bounced ? Math.floor((data?.bounced * 100) / data?.assigned) : data?.bounced
      },
      {
        label: 'Unsubscribed',
        count: data?.unsubscribed,
        percentage: data?.unsubscribed ? Math.floor((data?.unsubscribed * 100) / data?.assigned) : data?.unsubscribed
      }
    ]
  )
}

const getTotalPillData = (data: any) => {
  if(!data) return {totalCount: 0, totalPercentage: 0}
  const totalPillData = data?.reduce((acc:any,item:any)=>{
    acc.totalCount+=item.count
    acc.totalPercentage+=item.percentage
    return acc
  },{totalCount:0,totalPercentage:0})
  return totalPillData
}

const BootstrapTooltip = MUIStyled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#1D1934',
    left:'4px !important'
    
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#1D1934',
    minWidth:'224px',
    padding:'8px'
  },
}));



const getChartValues = (data: any, isWhatsAppCampaign:boolean) => {
  if(isWhatsAppCampaign){
    return [data?.assigned, data?.completed, data?.opened, data?.responded]
  }
  return [
    data?.assigned, data?.completed, data?.opened, data?.replied, data?.applied
  ]
}
  
const CampaignStageDetails = (props: CampaignStageDetailsPropsType) => {
  const { campaignStageData, isSelectedCampaign, isWhatsAppCampaign } = props;
  const { passiveJobCount } = campaignStageData || {}

  const pillDataArray = getPillData(campaignStageData, isWhatsAppCampaign);
  const pillTotalData = getTotalPillData(pillDataArray);
  const chartValueArray = getChartValues(campaignStageData, isWhatsAppCampaign);

  const iconRef = useRef<any>(null);

  const TooltipContent = <BootstrapTooltip
        placement="top-start"
        title={
          <ToolTipTitleContainer>
            {
              pillDataArray.map((pillData: DataPillProps, index: number) => {
                return (
                  <div style={{fontSize:'14px'}}>
                  {pillData.label} - {pillData.count} ({pillData.percentage}%)
              </div>
                )
              })
            }
          </ToolTipTitleContainer>
        }
        arrow
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [-180, -4], 
              },
            },
          ],
        }}

        >
        <IconButton aria-label="information" ref={iconRef}>
            <INFO_ICON/>
        </IconButton>
  </BootstrapTooltip>


  return (
    <TableCell sx={{ padding: '0 24px', width: `${TABLE_CONSTANTS.CAMPAIGN_STAGES}px`, minWidth: `${TABLE_CONSTANTS.CAMPAIGN_STAGES}px` }}>
      <Grid width={`${TABLE_CONSTANTS.CAMPAIGN_STAGES}px`} container direction={'column'}>
        <Grid item sx={{ height: '90px', display: 'flex', gap: '0.5rem', justifyContent: 'space-between' }}>
          <BarChart isWhatsAppCampaign={isWhatsAppCampaign} bars={chartValueArray} isSelectedCampaign={isSelectedCampaign}/>
          {campaignStageData?.isPassiveJob && (<div style={{
            justifyContent: 'flex-end',
            display: 'flex' }}>
            <div style={{width: '70px', maxWidth: '70px', minWidth: '70px', padding: '0 4px', borderRadius: '0 0 4px 4px', background: isSelectedCampaign? COLOR_MAP.WHITE: COLOR_MAP.WARNING_YELLOW}}>
            <GreenPassiveBox style={{ padding: '1px 4px', display: 'flex', flexDirection: 'column'}}>
              <div>{campaignStageData?.applied ? (Number(passiveJobCount) / Number(campaignStageData?.applied))?.toFixed(1) : 1}x</div>
              <div>of applies</div>
            </GreenPassiveBox>
            </div>
          </div>)}
        </Grid>
        <Grid item sx={{ display: 'flex', marginTop: ' 12px' }} gap={'12px'}>
          {
            pillDataArray && pillDataArray.length && pillTotalData ?
            <DataPillContainer>
              <InfoText>Not sent to </InfoText> 
              <InfoTextBold>{pillTotalData?.totalCount}</InfoTextBold> 
              <span> ({pillTotalData?.totalPercentage}%) </span> 
                {TooltipContent}
            </DataPillContainer>
            : null
           }
        </Grid>
        {isWhatsAppCampaign && <Grid item sx={{ display: 'flex', my: ' 12px' }} gap={'12px'}>
            <Box sx={{ backgroundColor: '#FFFAF1', py:1, px:0.5, borderRadius:'4px', width:'400px', boxSizing:'border-box'}}>
              <Typography sx={{fontSize:'12px', color:'#59566C', lineHeight:'16px'}}>
                Meta restricts marketing messages per user, so some assigned candidates may not receive this campaign.
              </Typography> 
            </Box>
          </Grid>
        }
      </Grid>
    </TableCell>
  )
}



export default CampaignStageDetails